import React from 'react';
import { Nav, Tab } from 'react-bootstrap';

interface Props {
  showMembership: boolean;
  details: React.ReactNode;
  membership?: React.ReactNode;
}

const ChurchEditorTabs: React.FC<Props> = ({ showMembership, details, membership }) => (
  <Tab.Container defaultActiveKey="details">
    <Nav variant="tabs" className="mb-3">
      <Nav.Item>
        <Nav.Link eventKey="details">Details</Nav.Link>
      </Nav.Item>
      {showMembership && (
        <Nav.Item>
          <Nav.Link eventKey="membership">Membership</Nav.Link>
        </Nav.Item>
      )}
    </Nav>
    <Tab.Content>
      <Tab.Pane eventKey="details">{details}</Tab.Pane>
      {showMembership && <Tab.Pane eventKey="membership">{membership}</Tab.Pane>}
    </Tab.Content>
  </Tab.Container>
);

export default ChurchEditorTabs;
